import axios from 'axios'
import initializers from './initializers'

export default axios
  .create({
    baseURL: initializers.recommends_host,
    timeout: 20000
  })
